/*
 * File: /src/services/agencyService.js
 * Created Date: Thursday April 2nd 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 2nd April 2020 5:09:20 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_AGENCY_PATH, AD_BASE_ACCOUNTS_PATH } from '../constants';

export default {
  /**
   * Simulate Client
   *
   * @param {*} id
   * @returns
   */
  simulateClient(id) {
    if (isNaN(+id)) return;
    return authedAxios.get(AD_BASE_AGENCY_PATH + 'simulate/' + +id).then(r => {
      return r;
    });
  },

  /**
   * Fetch all Users for Company
   *  - Admin only. will return 500 unless so.
   *
   * @param {*} id
   * @param {*} meta
   * @returns
   */
  fetchAllUsers(id) {
    return authedAxios.get(AD_BASE_ACCOUNTS_PATH + +id + '/agency/users/');
  },

  /**
   * Drop Company ID
   * - Admin Only. will return 500 unless so.
   *
   * @param {*} companyId
   * @param {*} userId
   * @returns
   */
  dropUserAccount(companyId, userId) {
    return authedAxios.delete(AD_BASE_ACCOUNTS_PATH + companyId + '/agency/users/' + userId);
  },

  addAgencyCompanyToUser(companyId, userId) {
    return authedAxios.post(AD_BASE_ACCOUNTS_PATH + companyId + '/agency/users/' + userId);
  }
};
